import ajax from '@/resources/myApi';

export const sharedService = {
    getLookupPhoneTypes,
};


async function getLookupPhoneTypes() {
    try {
        const { data } = await ajax.get(`api/LookupPhoneTypesView`);

        return data;

    } catch (error) {
        return {};
    }
}


export default sharedService;